<!-- Dashboard
<div class="menu-item me-lg-1">
  <a class="menu-link py-3" routerLinkActive="active" routerLink="/dashboard"
  ><span class="menu-title" translate="MENU.DASHBOARD"></span
  ></a>
</div>-->

<div class="menu-item me-lg-1">
  <a *ngIf="translate.currentLang === 'it'" class="menu-link py-3" (click)="openExternalLink('https://istitutomedicolegale.it/')"><span class="menu-title">Sito web IML</span></a>
  <a *ngIf="translate.currentLang === 'es'" class="menu-link py-3" (click)="openExternalLink('https://www.solucionmedicolegal.es/')"><span class="menu-title">Sitio web SML</span></a>
</div>

<div class="menu-item me-lg-1">
  <a *ngIf="translate.currentLang === 'it'" class="menu-link py-3" (click)="openExternalLink('https://istitutomedicolegale.it/comunicati/')"><span class="menu-title">Comunicati</span></a>
  <a *ngIf="translate.currentLang === 'es'" class="menu-link py-3" (click)="openExternalLink('https://www.solucionmedicolegal.es/blog/')"><span class="menu-title">Blog</span></a>
</div>

<div class="menu-item me-lg-1">
  <a *ngIf="translate.currentLang === 'it'" class="menu-link py-3" (click)="openExternalLink('https://istitutomedicolegale.it/contatti/')"><span class="menu-title">Hai bisogno di aiuto?</span></a>
  <a *ngIf="translate.currentLang === 'es'" class="menu-link py-3" (click)="openExternalLink('https://www.solucionmedicolegal.es/contacto/')"><span class="menu-title">¿Necesitas ayuda?</span></a>
</div>

<!-- Apps -->
<!--<div
  class="menu-item menu-lg-down-accordion me-lg-1"
  data-kt-menu-trigger="click"
  data-kt-menu-placement="bottom-start"
>
  <span class="menu-link py-3" [ngClass]="calculateMenuItemCssClass('/_apps')">
    <span class="menu-title">Menu a tendina</span>
    <span class="menu-arrow d-lg-none"></span>
  </span>
  <div
    class="
      menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0
      py-lg-4
      w-lg-225px
    "
    data-kt-menu-dismiss="true"
  >
    <div
      class="menu-item menu-lg-down-accordion me-lg-1"
      data-kt-menu-trigger="{default:'click', lg: 'hover'}"
      data-kt-menu-placement="right-start"
    >
      <span
        class="menu-link py-3"
        [ngClass]="calculateMenuItemCssClass('/_apps/chat')"
      ><span class="menu-icon"
      ><span
        class="svg-icon svg-icon-2"
        [inlineSVG]="'./assets/media/icons/duotune/general/gen022.svg'"
      ></span></span
      ><span class="menu-title" data-link="/_apps/chat">Campo 1</span
      ><span class="menu-arrow"></span
      ></span>
      <div
        class="
          menu-sub
          menu-sub-lg-down-accordion
          menu-sub-lg-dropdown
          menu-rounded-0
          py-lg-4
          w-lg-225px
        "
        data-kt-menu-dismiss="true"
      >
        <div class="menu-item me-lg-1">
          <a
            class="menu-link py-3"

          ><span class="menu-bullet"
          ><span class="bullet bullet-dot"></span></span
          ><span class="menu-title">Pagina 1</span></a
          >
        </div>
        <div class="menu-item me-lg-1">
          <a
            class="menu-link py-3"

          ><span class="menu-bullet"
          ><span class="bullet bullet-dot"></span></span
          ><span class="menu-title">Pagina 2</span></a
          >
        </div>
        <div class="menu-item me-lg-1">
          <a
            class="menu-link py-3"

          ><span class="menu-bullet"
          ><span class="bullet bullet-dot"></span></span
          ><span class="menu-title">Pagina 3</span></a
          >
        </div>
      </div>
    </div>
  </div>
</div>-->

<!-- MegaMenu -->
<!--<div-->
<!--  class="menu-item menu-lg-down-accordion me-lg-1"-->
<!--  data-kt-menu-trigger="click"-->
<!--  data-kt-menu-placement="bottom-start"-->
<!--&gt;-->
<!--  <span class="menu-link py-3">-->
<!--    <span class="menu-title">Accesso Rapido</span>-->
<!--    <span class="menu-arrow d-lg-none"></span>-->
<!--  </span>-->
<!--  <div-->
<!--    class="-->
<!--      menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown-->
<!--      w-100 w-lg-600px-->
<!--      p-5 p-lg-5-->
<!--    "-->
<!--    data-kt-menu-dismiss="true"-->
<!--  >-->
<!--    <div class="row" data-kt-menu-dismiss="true">-->
<!--      <div class="col-lg-4 border-left-lg-1">-->
<!--        <div class="menu-inline menu-column menu-active-bg">-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-lg-4 border-left-lg-1">-->
<!--        <div class="menu-inline menu-column menu-active-bg">-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-lg-4 border-left-lg-1">-->
<!--        <div class="menu-inline menu-column menu-active-bg">-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--          <div class="menu-item">-->
<!--            <a class="menu-link cursor-pointer"-->
<!--            ><span class="menu-bullet"-->
<!--            ><span class="bullet bullet-dot"></span></span-->
<!--            ><span class="menu-title">Example link</span></a-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
